import { attr } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';

const DeliveryAddress = ApplicationRecord.extend({
  attrs: {
    country_code: attr(),
    locality: attr(),
    postcode: attr(),
    street_1: attr(),
    street_2: attr(),
    street_3: attr(),
  },
  static: {
    jsonapiType: 'deliveries-delivery_addresses',
  },
});

export default DeliveryAddress;
